import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-differed-decision-introduction',
    templateUrl: './differed-decision-introduction.component.html',
    styleUrls: ['./differed-decision-introduction.component.scss'],
})
export class DifferedDecisionIntroductionComponent implements OnInit{
    showFaqModal = false;

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

    toggleFaq() {
        this.showFaqModal = !this.showFaqModal;
    }
}
